import { useMutation, UseMutationResult } from '@tanstack/react-query'

import { SaveBillingDataRequestDTO } from '@/core/api/dtos/request/account/saveBillingData'
import { accountService } from '@/core/api/services/account/accountService'

interface UseSaveBillingDataParams {
	accountId: number
	onSuccess?: () => void
	onError?: (error: any) => void
}

/**
 * Hook to save billing data for an account
 */
export const useSaveBillingData = ({
	accountId,
	onSuccess,
	onError,
}: UseSaveBillingDataParams): UseMutationResult<
	any,
	Error,
	SaveBillingDataRequestDTO
> => {
	return useMutation({
		mutationFn: (data: SaveBillingDataRequestDTO) => {
			return accountService.saveBillingData(accountId, data)
		},
		onSuccess: () => {
			onSuccess?.()
		},
		onError: (error: any) => {
			onError?.(error)
		},
	})
}
